import { alpha, Chip, chipClasses, styled } from '@mui/material';
import type { FormChipSelectedLook } from '@onevision-resources/design-theme';

interface ChoiceChipOwnerState {
  selected: boolean;
  look: FormChipSelectedLook;
}

const SELECTED_BACKGROUND_OPACITY = 0.16;
const SELECTED_BORDER_OPACITY = 0.55;

export const ChoiceChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'look',
})<ChoiceChipOwnerState>(({ theme, selected, look }) => {
  const { sys } = theme.palette.custom.OV;

  const selectedColors =
    look === 'tonal'
      ? {
          background: alpha(sys.secondary, SELECTED_BACKGROUND_OPACITY),
          border: alpha(sys.secondary, SELECTED_BORDER_OPACITY),
          text: sys.onBackground,
        }
      : { background: sys.primary, border: sys.primary, text: sys.onPrimary };

  const restingColors = {
    background: 'transparent',
    border: sys.outlineVariant,
    text: sys.onSurface,
  };
  const colors = selected ? selectedColors : restingColors;

  return {
    height: 'auto',
    gap: theme.spacing(0.625),
    padding: theme.spacing(0.625, 1.375),
    borderRadius: '6.25rem',
    fontSize: '0.75rem',
    fontWeight: 600,
    backgroundColor: colors.background,
    border: `1px solid ${colors.border}`,
    color: colors.text,
    [`& .${chipClasses.label}`]: { padding: 0 },
    [`& .${chipClasses.icon}`]: {
      margin: 0,
      width: '0.8125rem',
      height: '0.8125rem',
      fontSize: '0.8125rem',
      color: 'inherit',
    },
    '&&:hover, &&.Mui-focusVisible': {
      backgroundColor: selected ? selectedColors.background : sys.surfaceContainerHigh,
    },
  };
});
